<template>
  <div class="popup-subtitle">
    <slot />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.popup-subtitle {
  font-size: 20px;
  font-weight: 600;
  color: #09090B;
  margin-bottom: 16px;
}
</style>
